export default "__VITE_ASSET__gxgxBWx8__"